import { api, encodeFileName } from 'utility';
import queryString from 'query-string';
import {
  getCreditUrl,
  getRequestListUrl,
  getBusinessPhoneNumber,
  chequeInquiry,
  chequeRegistration,
  expertRequests,
  warrantiesDepositsList,
  warrantiesRetry,
  warrantiesCancel,
  getRequestWarrantyPriceTable,
  getRequestWarrantyLegalCustomer,
  getRequestListWarranties,
  getRequestListWarrantiesFile,
  getRequestListWarrantieUrl
  
} from 'URLs';
import pdfDownloader from '../../Financial/ReportSettlement/components/PdfDownloader';
/**
 * لغو درخواست  
 */

const source = api.cancelToken;
let cancelToken;

export function postWarrantiesCancel(code) {
  return api.put(warrantiesCancel(code)).then((res) => res.data);
}
/**
 * دریافت آخرین درخواست صدور ثبت شده
 */
export function getRequestOne(params) {
  return api.get(`${getRequestListUrl()}?${queryString.stringify(params,{ arrayFormat: 'repeat' })}`).then((res) => res.data);
}
/**
 * لیست ضمانت نامه ها - در تب اول - فعلا یک مورد برمیگرده
 */
export function getWarranyList(warrantyType) {
  if (cancelToken) {
    cancelToken.cancel('cancelToken');
  }
  cancelToken = source.source();
  return api.get(`${getRequestWarrantyPriceTable()}?warrantyType=${warrantyType}`, {cancelToken: cancelToken.token}).then((res) => res.data);
}



export function getRequestList(params) {
  return api.get(`${getRequestListUrl() +'?'+queryString.stringify(params, { arrayFormat: 'repeat' })}`).then((res) => res.data);
}
/**
 * دریافت قرارداد
 */

export function getExpertRequests(code) {
  const file_name = `contract-${code}.pdf`;
  return pdfDownloader(expertRequests(code), file_name);
}

/**
 * دریافت شماره موبایل کاربر لاگین شده
 */
export function getPhoneNumberUserLogin() {
  return api.get(getBusinessPhoneNumber(), {}).then((res) => res.data);

}

/**
 * ارسال  ثبت چک
 */

export function postChequeInquiry(data) {
  return api.post(chequeInquiry(), data).then((res) => res.data);
}
/**
 * درخواست مجدد
 */

export function postWarrantiesRetry(code, data) {
  return api.post(warrantiesRetry(code), data).then((res) => res.data);
}
export function postChequeRegistrationFinal(code, data) {
  return api.post(chequeRegistration(code), data).then((res) => res.data);
}


/**
 * دریافت لیست حساب ها
 */
export function getCredits() {
  return api.get(getCreditUrl(), {}).then((res) => res.data);
}
/**
 * دریافت لیست نمایندگانا
 */
export function getLoadLegalCustomers() {
  return api.get(getRequestWarrantyLegalCustomer(), {}).then((res) => res.data);
}
/**
 * آپلود مدارک در تب دوم تکمیل مدارک
 */
export function postChequeRegistration(params) {
  return api.post(getRequestWarrantyPriceTable(), { params }).then((res) => res.data);
}


/**
 * دریافت لیست ضمانت نامه ها - رادیو باتن ها از این سرویس دریافت میشود
 */
export function getWarrantiesDetailsRadioButton() {
  if (cancelToken) {
    cancelToken.cancel('cancelToken');
  }
  cancelToken = source.source();
  return api.get(getRequestListWarranties(), {cancelToken: cancelToken.token}).then((res) => res.data);
}

/**
 * آپلود مدارک در تب دوم تکمیل مدارک
 */
export function uploadFile(formData, body, name, type) {
  let str = queryString.stringify(body);
  return (
    api
      .post(getRequestListWarrantiesFile()+ '?' + str, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'file-type': type,
          'file-name': encodeFileName(name)
        },
      })
      .then((res) => res.data)
  );
}

/**
 * ثبت درخواست در مرحله دوم
 */
export function sabtInformationStep2(params, data) {
  return api.post(getRequestListWarranties(), { ...data }, { ...params }).then((res) => res.data);
};

/**
 * ویرایش  اطلاعات ضمانت نامه مرحله دوم
 */
export function editInformationStep2(params, data, entityId) {
  return api.patch(getRequestListWarrantieUrl(entityId), { ...data }, { ...params }).then((res) => res.data);
}

/**
 * دریافت لیست حساب های سنتی
 */
export function getDepositList() {
  return api.get(warrantiesDepositsList(), {}).then((res) => res.data);
}

export default {
  getCredits,
  getRequestOne,
  getPhoneNumberUserLogin,
  getWarranyList,
  uploadFile,
  getLoadLegalCustomers,
  postChequeInquiry,
  postChequeRegistration,
  postChequeRegistrationFinal,
  sabtInformationStep2,
  editInformationStep2,
  getRequestList,
  getExpertRequests,
  pdfDownloader,
  getDepositList,
  postWarrantiesRetry,
  postWarrantiesCancel,
  getWarrantiesDetailsRadioButton
};
